import { Injectable, OnInit } from '@angular/core';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { StorageService } from '../interceptor/storage.service';
import { AllinoneService } from './allinone.service';

@Injectable({
  providedIn: 'root',
})
export class CheckerService implements OnInit{

  usertax:any;

  constructor( private store: StorageService, private router: Router, private serv: AllinoneService) {}


 ngOnInit(): void {}


 checkDetails() {
  const userDetails:any = this.store.getuser();
    const userroles:any = this.store.getRoles();
    // console.log(userDetails)
    if( userDetails !=null ||  userDetails !=undefined){
     if( userDetails?.lockStatus == true){
        this.setpopup2();
        this.router.navigate(['/profile']);
    }
     else if( userDetails?.phoneNumbers.length == 0 && userroles != 'ADMIN'){
        this.setpopup("Contact");
        this.router.navigate(['/profile']);
      }

       else if( userDetails?.addresses.length == 0 && userroles != 'ADMIN'){
         this.setpopup("Address");
         this.router.navigate(['/profile']);
        }
        else if( userDetails?.emails.length == 0){
            this.setpopup("Email");
            this.router.navigate(['/profile']);
        }
        else if( userDetails?.experiences.length == 0 && (userroles != 'OWNER' && userroles != 'ADMIN')){
            this.setpopup("Experience");
            this.router.navigate(['/profile']);
        }
    }
 }

 setpopup(data:any){
    Swal.fire({
        title: `Please update your`,
        text: `${data} details`,
        icon: 'warning',
        allowOutsideClick: false,
        showCancelButton: false,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'OK'
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.close();
        }
      });
    }

    setpopup2(){
        Swal.fire({
            title: 'Please de-activate your profile',
            icon: 'warning',
            allowOutsideClick: false,
            showCancelButton: false,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'OK'
          }).then((result) => {
            if (result.isConfirmed) {
              Swal.close();
            }
          });
        }

}


